// "검차 화면으로 보기" 진입점 (A5 / A5-R) — 차량관리 셸 앱바·모바일 헤더·설정 행 세 자리에서 쓴다.
// 조건은 canOfferSimple(user)(허용 role — 업체 플래그 무관) + 검차 셸이 아닐 때(크롬 변형의 차량관리 화면에선 숨김).
// 확인 시트(A5-S)를 거쳐 setChoice('simple') → 셸이 /main/s/home 으로 되돌린다.
// props: { user, variant: 'bar' | 'header' | 'row' }
import React, { useState } from 'react';
import { T, R } from '../theme';
import { useT } from '../../i18n/I18nProvider';
import { canOfferSimple, useScreenMode } from './screenMode';
import { SIMPLE_HOME, isManagePath } from './routes';
import ConfirmSheet from './parts/ConfirmSheet';

var btn = { display: 'inline-flex', alignItems: 'center', gap: 6, height: 28, padding: '0 10px',
  borderRadius: R.md, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap', cursor: 'pointer',
  fontFamily: 'inherit', boxSizing: 'border-box', maxWidth: 220, overflow: 'hidden' };
var accent = { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress };
var card = { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginTop: 4, padding: '12px 14px',
  background: T.head, border: '1px solid ' + T.bd, borderRadius: R.card };
var cardText = { fontSize: 12.5, color: T.muted, flex: 1, minWidth: 200 };

function Glyph() {
  return (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" aria-hidden="true" focusable="false"><path d="M4 6h16M7 12h10M10 18h4" /></svg>);
}

function BackToSimple(props) {
  var t = useT();
  var sm = useScreenMode(props.user);
  var st = useState(false);
  var open = st[0], setOpen = st[1];

  if (!canOfferSimple(props.user) || sm.simpleActive) return null;

  // navigate 를 쓰지 않는다 — 선택이 바뀌면 Dashboard 래퍼가 SimpleShell 로 갈아끼우고,
  // 셸의 catch-all 라우트가 /main/s/home 으로 되돌린다(설정 화면처럼 Router 밖에서 렌더될 수도 있다).
  // 단 차량관리 허용 경로(routes.isManagePath)는 크롬 변형으로 남으므로 검차 홈으로 직접 보낸다 — 전체 리로드(어차피 셸 교체).
  var go = function () {
    setOpen(false);
    sm.setChoice('simple');
    if (isManagePath(window.location.pathname)) window.location.assign(SIMPLE_HOME);
  };
  var sheet = (<ConfirmSheet open={open} title={t('simpleB1ShowSimpleSheetTitle')}
    headline={t('simpleB1SheetSimpleHeadline')} sub={t('simpleB1SheetSimpleSub')} hint={t('simpleB1ShowSimpleHint')}
    confirmLabel={t('simpleBackToSimple')} onConfirm={go} onClose={function () { setOpen(false); }} />);

  if (props.variant === 'row') {
    return (<div className="ss-back-row" style={card}>
      <span style={cardText}>{t('simpleBackToSimpleSub')}</span>
      <button type="button" data-testid="back-to-simple" style={Object.assign({}, btn, accent, { height: 32 })}
        onClick={function () { setOpen(true); }}><Glyph />{t('simpleBackToSimple')}</button>
      {sheet}
    </div>);
  }

  return (<React.Fragment>
    <button type="button" data-testid="back-to-simple" className={'ss-back-' + (props.variant || 'bar')}
      style={Object.assign({}, btn, accent)} onClick={function () { setOpen(true); }}>
      <Glyph />{t('simpleBackToSimple')}
    </button>
    {sheet}
  </React.Fragment>);
}

export default BackToSimple;
